// extracted by mini-css-extract-plugin
export default {"wrapper":"G077da5","resetFormTitle":"G5890fd","resetPasswordButton":"G32a2ab"};